import React from "react";
import Head from "next/head";

import { AnnouncementType } from "@/@types/Annoucement";
import Announcement from "@/components/media/announcement";
import { announcementsData } from "@/components/media/announcement-data";
import { GetStaticProps } from "next/types";

type Props = {
  announcement: AnnouncementType;
};

const MediaAnnouncement = ({ announcement }: Props) => {
  if (!announcement) return <></>;

  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <title>{announcement.title}</title>
        <link
          rel="canonical"
          href={`https://www.shipvista.com/media/newsroom/${announcement.id}`}
        />
        <meta name="description" content={announcement.subtitle}></meta>
        <meta
          name="twitter:card"
          content={`https://www.shipvista.com/media/newsroom/${announcement.id}`}
        />
        <meta name="twitter:image" content={announcement.imagePath} />
        <meta name="twitter:title" content={announcement.title} />
        <meta name="twitter:creator" content="@shipvista" />
        <meta name="twitter:site" content="@shipvista" />
        <meta name="twitter:description" content={announcement.subtitle} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="www.shipvista.com" />
        <meta property="og:title" content={announcement.title} />
        <meta property="og:description" content={announcement.subtitle} />
        <meta property="og:image" content={announcement.imagePath} />
      </Head>
      <Announcement announcement={announcement} />
    </>
  );
};

export async function getStaticPaths() {
  // Generate the paths for each news item
  const paths = announcementsData.map((newsId) => ({
    params: { newsId: `${newsId.id}` },
  }));

  return {
    paths,
    // output:"export" forbids fallback:true|blocking; full path set enumerated above.
    fallback: false,
  };
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  if (!params || !params.newsId) {
    return { notFound: true };
  }

  let announcement: AnnouncementType | undefined = undefined;
  const newsId = Number(params.newsId);

  if (!isNaN(newsId)) {
    announcement = announcementsData.find(({ id }) => id === newsId);
  }

  if (!announcement) {
    return { notFound: true };
  }

  return {
    props: { announcement },
  };
};

export default MediaAnnouncement;
